import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  url = environment.baseURL + 'login';


  constructor(private http: HttpClient) { }

  login(user, password): Observable<any> {
    const urlLogin = this.url;
    return this.http.post<any>(urlLogin, {
      username: user,
      password: password
    });
  }

}
